import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cac8702"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex align-items-center justify-content-between flex-wrap gap-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "project-hero" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "project-hero__icon" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-solar-power" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "project-hero__copy" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "project-hero__name" }, "Solar power plant"),
    /*#__PURE__*/_createElementVNode("p", { class: "project-hero__lead" }, " Key contractual milestones and installed capacity used by tariff and deemed-energy calculations. ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "project-hero__status" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "project-hero__status-label" }, "Status"),
    /*#__PURE__*/_createElementVNode("span", { class: "project-hero__status-value" }, "In commercial operation")
  ])
], -1))
const _hoisted_3 = { class: "project-section" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "project-section__title" }, "Milestones", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "project-section__lead" }, " Dates that define the transition from initial to full commercial operation. ", -1))
const _hoisted_6 = { class: "project-grid" }
const _hoisted_7 = { class: "project-fact__body" }
const _hoisted_8 = { class: "project-fact__label" }
const _hoisted_9 = { class: "project-fact__value" }
const _hoisted_10 = {
  key: 0,
  class: "project-fact__hint"
}
const _hoisted_11 = { class: "project-section" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "project-section__title" }, "Installed capacity", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "project-section__lead" }, " AC power ratings used for pre-COD scaling (IPNOM / PNOM) in settlement. ", -1))
const _hoisted_14 = { class: "project-grid" }
const _hoisted_15 = { class: "project-fact__body" }
const _hoisted_16 = { class: "project-fact__label" }
const _hoisted_17 = { class: "project-fact__value mono" }
const _hoisted_18 = {
  key: 0,
  class: "project-fact__hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WTitle = _resolveComponent("WTitle")!
  const _component_WSubTitle = _resolveComponent("WSubTitle")!
  const _component_PCard = _resolveComponent("PCard")!

  return (_openBlock(), _createBlock(_component_PCard, { class: "project-page" }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_WTitle, { text: "Project" }),
          _createVNode(_component_WSubTitle, { text: "Commissioned plant identity and contract power ratings" })
        ])
      ])
    ]),
    content: _withCtx(() => [
      _hoisted_2,
      _createElementVNode("section", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.milestones, (item) => {
            return (_openBlock(), _createElementBlock("article", {
              key: item.key,
              class: "project-fact"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(['project-fact__icon', `project-fact__icon--${item.tone}`])
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(item.icon)
                }, null, 2)
              ], 2),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(item.label), 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString(item.value), 1),
                (item.hint)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(item.hint), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("section", _hoisted_11, [
        _hoisted_12,
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.capacity, (item) => {
            return (_openBlock(), _createElementBlock("article", {
              key: item.key,
              class: "project-fact"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(['project-fact__icon', `project-fact__icon--${item.tone}`])
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(item.icon)
                }, null, 2)
              ], 2),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(item.label), 1),
                _createElementVNode("span", _hoisted_17, _toDisplayString(item.value), 1),
                (item.hint)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(item.hint), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}